import type { ExplorationAccountCache, ExplorationVolume } from '../types/exploration';

export function buildInstanceMap(volumes: ExplorationVolume[]) {
  const instanceMap: ExplorationAccountCache['instanceMap'] = {};
  volumes.forEach((v) => {
    if (v.instanceId && !instanceMap[v.instanceId]) {
      instanceMap[v.instanceId] = {
        id: v.instanceId,
        name: v.instanceId,
        type: null,
        region: v.region,
        cluster: v.cluster,
        nodeGroup: v.nodeGroup,
      };
    }
  });
  return instanceMap;
}

export function buildAccountCache(
  accountId: string,
  name: string,
  volumes: ExplorationVolume[]
): ExplorationAccountCache {
  const instanceMap = buildInstanceMap(volumes);
  return {
    name,
    label: name,
    volumes,
    instances: Object.values(instanceMap),
    instanceMap,
    hasUtilization: volumes.some((v) => v.usedGiB !== null),
  };
}
